export default {
    '1': '单位类别',
    '2': '物料类别',
    '3': '入库单',
    '4': '出库单',
    '5': '设备分类',
    '6': '设备产权',
    '7': '产品分类',
}